import { create } from "zustand";
import { Profile } from "../models/Profile";
import { getProfile } from "../repositories/UserRepository";
import { LoginDto } from "../models/dto/LoginDTO";

export interface UserStore {
  user?: Profile;
  fetchProfile: (loginData: LoginDto) => Promise<number | undefined>;
  logout: () => void;
}

export const useProfile = create<UserStore>((set) => ({
  user: (() => {
    const saved = localStorage.getItem("user");
    return saved ? JSON.parse(saved) : undefined;
  })(),
  fetchProfile: (loginData: LoginDto) => {
    return getProfile(set, loginData);
  },
  logout: () => {
    localStorage.removeItem("user");
    set({ user: undefined });
  },
}));
